var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card-title",
        {
          staticClass: "pt-0"
        },
        [_vm._v(" Domain Registration ")]
      ),
      !_vm.isProfileFilled
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "error",
                        dense: ""
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "white--text fw-bold underline",
                          attrs: {
                            to: {
                              name: "profile_info"
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.empty_profile_text) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.step_counter,
                        callback: function callback($$v) {
                          _vm.step_counter = $$v
                        },
                        expression: "step_counter"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step_counter > 1,
                                step: "1"
                              }
                            },
                            [_vm._v(" Search for a domain ")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step_counter > 2,
                                step: "2"
                              }
                            },
                            [_vm._v(" Fill account information ")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.step_counter > 3,
                                step: "3"
                              }
                            },
                            [_vm._v(" Fill payment method ")]
                          ),
                          _c("v-divider"),
                          _c("v-stepper-step", {
                            attrs: {
                              step: "4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        [
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "1"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-container",
                                    {
                                      staticClass: "fill-height",
                                      attrs: {
                                        fluid: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "fill-height"
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "align-center flexbox",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-form",
                                                {
                                                  on: {
                                                    submit: _vm.searchDomain
                                                  }
                                                },
                                                [
                                                  _vm.step_counter === 1
                                                    ? _c("gg-text-field", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              _vm.rules.domain,
                                                            expression:
                                                              "rules.domain"
                                                          }
                                                        ],
                                                        attrs: {
                                                          outlined: "",
                                                          clearable: "",
                                                          label:
                                                            "Enter your domain",
                                                          color: "primary",
                                                          "data-vv-name":
                                                            "domain",
                                                          "data-vv-as":
                                                            "Domain",
                                                          "error-messages": _vm.errors.collect(
                                                            "domain"
                                                          )
                                                        },
                                                        on: {
                                                          "click:clear":
                                                            _vm.clearSearchData
                                                        },
                                                        model: {
                                                          value: _vm.search,
                                                          callback: function callback(
                                                            $$v
                                                          ) {
                                                            _vm.search = $$v
                                                          },
                                                          expression: "search"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      attrs: {
                                                        type: "submit",
                                                        loading:
                                                          _vm.buttons.step_one
                                                      },
                                                      on: {
                                                        click: _vm.searchDomain
                                                      }
                                                    },
                                                    [_vm._v(" Domain Lookup ")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-card-text", [
                                    !_vm.isEmpty && _vm.domain.available === 1
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "subtitle-1"
                                              },
                                              [
                                                _vm._v(" Domain "),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.domain.domain)
                                                  )
                                                ]),
                                                _vm._v(
                                                  " is available! Only $" +
                                                    _vm._s(
                                                      _vm.domain.pricing["1"]
                                                    ) +
                                                    "/year "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "gg-btn",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    _vm.step_counter = 2
                                                  }
                                                }
                                              },
                                              [_vm._v(" Go to the next step ")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.isEmpty && _vm.domain.available !== 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "subtitle-1"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(" Domain "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.domain.domain)
                                                )
                                              ]),
                                              _vm._v(
                                                " is not available. Please try another domain. "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "2"
                              }
                            },
                            [
                              _vm.step_counter === 2
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass:
                                            "app-card card-borderless"
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-form",
                                                {
                                                  on: {
                                                    submit:
                                                      _vm.accountInformation
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      attrs: {
                                                        fluid: ""
                                                      }
                                                    },
                                                    [
                                                      _vm.isAttributes
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "v-row",
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "app-card-title pl-0"
                                                                    },
                                                                    [
                                                                      _c("h3", [
                                                                        _vm._v(
                                                                          "Domain Attributes"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  ),
                                                                  _vm._l(
                                                                    _vm
                                                                      .ExtAttributes
                                                                      .Attribute,
                                                                    function(
                                                                      attribute,
                                                                      key
                                                                    ) {
                                                                      return _c(
                                                                        "v-col",
                                                                        {
                                                                          key: "attribute-".concat(
                                                                            key
                                                                          ),
                                                                          staticClass:
                                                                            "pb-0",
                                                                          attrs: {
                                                                            cols:
                                                                              "12"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .attrsVisibility[
                                                                            attribute
                                                                              .Name
                                                                          ] &&
                                                                          _vm.isEditableAttribute(
                                                                            attribute
                                                                          )
                                                                            ? _c(
                                                                                _vm.defineAttributeComponent(
                                                                                  attribute
                                                                                ),
                                                                                {
                                                                                  directives: [
                                                                                    {
                                                                                      name:
                                                                                        "validate",
                                                                                      rawName:
                                                                                        "v-validate",
                                                                                      value: _vm.attributeValidationRules(
                                                                                        attribute
                                                                                      ),
                                                                                      expression:
                                                                                        "attributeValidationRules(attribute)"
                                                                                    }
                                                                                  ],
                                                                                  tag:
                                                                                    "component",
                                                                                  attrs: {
                                                                                    outlined:
                                                                                      "",
                                                                                    name:
                                                                                      attribute.Name,
                                                                                    items: _vm.resolveItems(
                                                                                      attribute
                                                                                        .Options
                                                                                        .Option
                                                                                    ),
                                                                                    "true-value":
                                                                                      "Y",
                                                                                    label: _vm.getAttributeLabel(
                                                                                      attribute
                                                                                    ),
                                                                                    "false-value":
                                                                                      "N",
                                                                                    "error-messages": _vm.errors.collect(
                                                                                      attribute.Name
                                                                                    ),
                                                                                    "item-text":
                                                                                      "Title",
                                                                                    "item-value":
                                                                                      "Value"
                                                                                  },
                                                                                  on: {
                                                                                    change:
                                                                                      _vm.computeAttributes
                                                                                  },
                                                                                  model: {
                                                                                    value:
                                                                                      _vm
                                                                                        .model
                                                                                        .attributes[
                                                                                        attribute
                                                                                          .Name
                                                                                      ],
                                                                                    callback: function callback(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .model
                                                                                          .attributes,
                                                                                        attribute.Name,
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "model.attributes[attribute.Name]"
                                                                                  }
                                                                                }
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "subtitle-1"
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "No additional information is needed for this Domain. Please proceed to the next step."
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        secondary: ""
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          _vm.step_counter = 1
                                                        }
                                                      }
                                                    },
                                                    [_vm._v(" Back ")]
                                                  ),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      attrs: {
                                                        primary: "",
                                                        type: "submit"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.accountInformation
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Go to the payment "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "3"
                              }
                            },
                            [
                              _vm.step_counter === 3
                                ? _c(
                                    "v-card",
                                    {
                                      attrs: {
                                        elevation: "0"
                                      }
                                    },
                                    [
                                      _c("v-card-title", [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "subtitle-1"
                                          },
                                          [_vm._v("Domain addons")]
                                        )
                                      ]),
                                      _c(
                                        "v-card-text",
                                        _vm._l(_vm.domain.options, function(
                                          item,
                                          key,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index
                                            },
                                            [
                                              item.type === "checkbox"
                                                ? _c("v-checkbox", {
                                                    staticStyle: {
                                                      margin: "0",
                                                      padding: "0"
                                                    },
                                                    attrs: {
                                                      label: item.title,
                                                      disabled: _vm.handleDisabledCheckbox(
                                                        item.title
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.options_model[key],
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.options_model,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options_model[key]"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "payment-gateway",
                                {
                                  ref: "paymentGateway",
                                  on: {
                                    gateway: _vm.listenGateway,
                                    card: _vm.listenCard,
                                    "card-switch": _vm.listenCardNew
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    {
                                      slot: "header"
                                    },
                                    [_c("h3", [_vm._v("Payment method")])]
                                  ),
                                  _c(
                                    "template",
                                    {
                                      slot: "actions"
                                    },
                                    [
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            secondary: ""
                                          },
                                          on: {
                                            click: function click($event) {
                                              _vm.step_counter = 2
                                            }
                                          }
                                        },
                                        [_vm._v("Back")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            primary: "",
                                            loading: _vm.buttons.purchaseDomain
                                          },
                                          on: {
                                            click: _vm.orderDomain
                                          }
                                        },
                                        [_vm._v("Purchase domain")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              attrs: {
                                step: "4"
                              }
                            },
                            [
                              _vm.step_counter === 4
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass:
                                            "app-card card-borderless"
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass: "pl-0"
                                            },
                                            [
                                              _vm._v(
                                                " Domain Registration Order Received "
                                              )
                                            ]
                                          ),
                                          _c("v-card-text", [
                                            _c("p", [
                                              _vm._v(
                                                " Thank you! Your domain registration order has been received and will be processed shortly. "
                                              )
                                            ]),
                                            _c("p", [
                                              _vm._v(" Your order number is "),
                                              _c("strong", [
                                                _vm._v(
                                                  "#" + _vm._s(_vm.orderid)
                                                )
                                              ])
                                            ])
                                          ]),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _c(
                                                "gg-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    tile: "",
                                                    to: {
                                                      name: "domains"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Return to My Domains "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }